module.exports = __webpack_public_path__ + "static/60-genesis-3226ef65e2cdc9bc45383085c40b1434.png";